import { EnqueueSnackbar } from 'notistack'

import Api from '../../../../utils/api'

export const updateRowPosition = async (
  initialIndex: number,
  newIndex: number,
  rows: IUserType[],
  folder: IFolderType | undefined,
  enqueueSnackbar: EnqueueSnackbar,
  setPeopleTableData: React.Dispatch<React.SetStateAction<IUserType[]>>,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setFolderAttributes: React.Dispatch<React.SetStateAction<IFolderAttributesType | undefined>>,
  host: string
) => {
  if (folder && newIndex !== initialIndex) {
    const row = rows[initialIndex]
    if ((row.preferences?.notification?.length ?? 0) === 0) {
      enqueueSnackbar('Cannot change the notification priority of a contact with no notification preferences set', { variant: 'error' })
      setPeopleTableData([...rows]) // reset the table to its original state
    } else {
      setIsLoading(true)
      const reorderedRows = [...rows]
      const [removed] = reorderedRows.splice(initialIndex, 1)
      reorderedRows.splice(newIndex, 0, removed)
      const newNotifyPriority = reorderedRows.map((c) => c.id)
      const res = await Api.post(`${host}/api/v2/protect/folders/${folder.id}/notification-priority`, {
        userIds: newNotifyPriority,
      })
      if (res.ok) {
        setFolderAttributes((prev) => (prev ? { ...prev, notifyPriority: newNotifyPriority } : prev))
      } else {
        enqueueSnackbar('Something went wrong, and the notification priority order could not be updated', { variant: 'error' })
      }
      setIsLoading(false)
    }
  }
}

export const sortFolderUsers = (users: IUserType[], notifyPriority: number[] | undefined) =>
  notifyPriority
    ? users.sort((a, b) => {
        // Move Do not contact users to the bottom of the list
        if ((a.preferences?.notification?.length ?? 0) === 0 || (b.preferences?.notification?.length ?? 0) === 0)
          return (a.preferences?.notification?.length ?? 0) === 0 ? 1 : -1
        // Move users that are not in notifyPriority to the bottom of the list
        if (!notifyPriority.includes(a.id) || !notifyPriority.includes(b.id)) return !notifyPriority.includes(a.id) ? 1 : -1
        // Sort by notifyPriority
        return notifyPriority.indexOf(a.id) > notifyPriority.indexOf(b.id) ? 1 : -1
      })
    : users.sort((a, b) => {
        const nameA = `${a.information?.first} ${a.information?.last}`
        const nameB = `${b.information?.first} ${b.information?.last}`
        return nameA.localeCompare(nameB)
      })
